import { Link } from "react-router-dom";

const safetyItems = [
  {
    icon: "ri-shield-check-line",
    title: "认准官方渠道",
    desc: "仅通过本导航站或官方认证渠道获取访问地址，不点击不明来源的链接。",
  },
  {
    icon: "ri-lock-line",
    title: "检查HTTPS加密",
    desc: "访问前确认地址栏有安全锁图标，确保数据传输经过加密保护。",
  },
  {
    icon: "ri-eye-off-line",
    title: "保护个人隐私",
    desc: "不在不安全的网络环境下登录账号，定期修改密码并开启安全验证。",
  },
  {
    icon: "ri-alert-line",
    title: "警惕钓鱼网站",
    desc: "仔细核对域名拼写，虚假网站常通过相似域名诱导用户输入账号密码。",
  },
];

export default function SafetyTipsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-shield-check-line text-accent-500 mr-2"></i>
            安全访问须知
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm">
            保护您的账号安全与隐私，请务必阅读以下安全须知
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {safetyItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 text-sm mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/safety-tips"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors cursor-pointer"
          >
            了解更多安全知识
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}